import { SessionsCarousel } from './SessionsCarousel';

export default SessionsCarousel;
